export default {
  'internalError.title': 'Internal Server Error',
  'internalError.desc':
    "Whoops! Something went wrong. There's an unexpected error while processing your request. We will fix the problem as soon as possible.",
  'internalError.toHome': 'Return to Dashboard',
};
